export function orderClassifications(classifications) {
  return classifications?.sort((a, b) => {
    if (a?.agency === null && b?.agency !== null) return -1
    if (a?.agency !== null && b?.agency === null) return 1
    if (a?.agency === null && b?.agency === null) {
      return (a?.classificationName || '').localeCompare(b?.classificationName || '')
    }
    if (a?.agency !== null && b?.agency !== null) {
      return (a?.classificationName || '').localeCompare(b?.classificationName || '')
    }
    return 0
  })
}
